import { useTranslation } from 'react-i18next';
import TransportDocumentForm from '../form/TransportDocumentForm';
import { EnhancedDialog } from 'components/enhanced';

const TRANSLATION_PREFIX = 'pages.invoices.update';

interface InvoiceAddDDTDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: any) => void;
  supplierId: number;
}

export const InvoiceAddDDTDialog = ({
  isOpen,
  onClose,
  onSubmit,
  supplierId
}: InvoiceAddDDTDialogProps) => {
  const { t } = useTranslation();

  return (
    <EnhancedDialog
      open={isOpen}
      onClose={onClose}
      title={t(`${TRANSLATION_PREFIX}.add-transport-document`)}
      subTitle={t(`${TRANSLATION_PREFIX}.add-transport-document-subtitle`)}
      submitLabel={t('actions.add')}
      cancelLabel={t('actions.cancel')}
      maxWidth="sm"
      submitButtonProps={{
        type: 'submit',
        form: 'newInvoice'
      }}>
      <TransportDocumentForm onSubmit={onSubmit} supplierId={supplierId} />
    </EnhancedDialog>
  );
};

export default InvoiceAddDDTDialog;
